import getCurrentUser from '../utils/getCurrentUser'
import isBrowser from '../utils/isBrowser'

const PINTEREST_TAG_ID = 2612738759229

export function initializePinterestTag() {
  const user = getCurrentUser()
  if (isBrowser() && window.pintrk) {
    window.pintrk(
      'load',
      `${PINTEREST_TAG_ID}`,
      user?.email
        ? {
            em: user.email,
          }
        : undefined,
    )
    window.pintrk('page')
  }
}
